import CasosList from "./CasosList";

// Gestión de Casos Cualitativos: la pantalla de Gestión Pre-Judicial en modo cualitativo.
const CasosCualitativosList = () => <CasosList modo="cualitativo" />;

export default CasosCualitativosList;
